import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const GetChroniqueurById = (id_ean: string) => {
  return apiInstance.get(ApiPathConfig.CHRONIQUEUR_BY_ID(id_ean))
}

export default GetChroniqueurById
